import React from 'react';
import {TemplateForm} from '../../components/Template/Form';
import {useCreateTemplate} from '../../hooks/templates';

export const CreateTemplate = () => {
  const createData = useCreateTemplate();
  return <TemplateForm mode={'create'} formData={createData} />;
};
